export default __webpack_public_path__ + "static/media/popular2.ed2b8217.png";